<template>
  <div id="app">
    <header>
      <div class="logo"><a href="/"><img src="./assets/logo.jpg"></a></div>
      <div class="label-box">
        <label><a target="_blank" href="https://user-v.rs-jinhuizixun.com/">用户中心</a></label>
        <label><a href="/#/Service/">私人订制</a></label>
        <!-- <label><a href="http://user.rs-jinhuizixun.com/ArticlePage/19" target="_blank">新手指南</a></label> -->
        <label @click="show_weixin = true"><i class="fa fa-weixin" aria-hidden="true"></i>&nbsp;关注我们</label>
        <label class="o"><a target="_blank" :href="$config.apibase+'/index.php/api/upload/downloadShortcuts'">保存到桌面</a></label>
      </div>
      <div class="icons">
         
      </div>
    </header> 
    <div class="el-menu-box">
      <el-menu :default-active="activeIndex" :router="true" class="el-menu-demo" mode="horizontal" >
        <el-menu-item index="/Newsflash">7x24h快讯</el-menu-item>
        <el-menu-item index="/EconomicCalendar">财经日历</el-menu-item>
        <el-menu-item index="/information_list/prediction">金汇预报</el-menu-item>
        <el-menu-item index="/information_list/weekly">金汇周报</el-menu-item>
        <el-menu-item index="/information_list/morningpaper">金汇早报</el-menu-item>
        <el-menu-item index="/information_list/close">金汇内参</el-menu-item>
        <el-menu-item index="/etfposition">ETF持仓</el-menu-item>
        <el-menu-item index="/information_list/news">行业新闻</el-menu-item>
        <el-menu-item index="/information_list/notice">金汇通知</el-menu-item>
      </el-menu>
    </div>
    <router-view></router-view>
    <el-dialog top="3%" title="扫码关注公众号" size="tiny" :modal-append-to-body="false" :visible.sync="show_weixin">
      <img style="width:100%;" src="./assets/images/qrcode_for_gh_3c0cf27cfbd1_430.jpg"/>
      <p style="text-align:center;">扫码关注“每天都想看的资讯” </p>
    </el-dialog>
    <footer>
      <el-row>
        <el-col :span="15">
          <div class="label-box">
            <label @click="$router.push({path:'/AboutUs'});">关于我们</label>
            <label @click="$router.push({path:'/AdCooperation'});">广告合作</label>
            <label @click="$router.push({path:'/EliteRecruitment'});">精英招聘</label>
            <label @click="$router.push({path:'/Feedback'});">意见反馈</label>
            <label @click="$router.push({path:'/TermsOfUse'});">使用条款</label>
            <label @click="$router.push({path:'/ContactUs'});">联系我们</label>
          </div>
        </el-col>
        <el-col :span="9">
          <p style="text-align:center;font-size:12px;line-height:1.5;color:#7d90a0;">
            金汇资讯 海南省瑞圣科技有限公司 版权所有 <a target="_blank" style="color:#7d90a0;" href="https://beian.miit.gov.cn/">琼ICP备2024029969号-1</a><br>
            Copyright © 2012 - {{new Date().getFullYear()}} jinhuizixun.com All Rights Reserved
          </p>
        </el-col>
      </el-row>
    </footer>
  </div>
</template>
<script>
  export default {
    name:'app',
    data() {
      return {
        user: null,
        show_weixin: false,
        is_login: true,
        activeIndex: ''
      };
    },
    created(){
      this.setNav(this.$route.path);
      this.get_user();
    },
    watch: {
      '$route.path': {
        handler:function(val){
          this.setNav(val);
          this.get_user();
        }
      }
    },
    methods:{
      get_user : function(){
        let self = this;
        this.$http.get(this.$config.apibase + '/index.php/api/user/get_guest.html',).then(function(response){
          if(response.data.state == 0){
            self.user = response.data.user;
          }
        });
      },
      setNav(name){
        this.activeIndex = name;
      }
    }
  }
</script>
<style>
#app {
  font-family: '微软雅黑', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// App.vue?795acb0a